// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".quill-editor .ql-editor{min-height:10rem}.quill-editor .ql-editor.ql-blank:before{font-family:Heebo;font-style:normal;font-weight:400;font-size:1rem}.quill-editor .ql-editor p{margin-bottom:1rem}.quill-editor .ql-container.ql-snow.ql-disabled{border:none!important}.quill-editor .ql-editor[contenteditable=false]{background-color:#eeeff8!important;border:1px solid #d1d2db;border-radius:.29rem}", ""]);
// Exports
module.exports = exports;
